import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findMedicationRequests = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/medication-requests${query}`,
    {
      headers,
    },
  );
};

export const findMedicationRequestById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_INFO_API_URL}/medication-requests/${id}`,
    {
      headers,
    },
  );
};

export const updateMedicationRequest = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/medication-requests/${id}`,
    data,
    {
      headers,
    },
  );
};
